import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const search_action: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, [
      'generatedResult',
      'highlightedText',
      'feedbackSentiment',
      'feedbackText',
      'resultCount',
    ]),
  }),
  addContexts: ({ eventData } = {}) => {
    const customEntities = eventData?.entities ?? [];
    return createContexts(customEntities, { eventData });
  },
};
